import {
  Component,
  Input,
  OnInit,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { HttpParams } from "@angular/common/http";
import { CompanyRepository } from "../../../company/company.repository";
import { Company } from "../../../company/company.model";
import { UserService } from "app/user/user.service";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface CompanyChangeEvent {
  originalEvent: MouseEvent;
  value: Company;
}

@Component({
  selector: "app-company-select",
  styleUrls: ["./company-select.component.scss"],
  templateUrl: "./company-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class CompanySelectComponent implements OnInit {
  private companyRepository = inject(CompanyRepository);
  private userService = inject(UserService);

  public readonly companyChange = output<Company[]>();
  @Input() public company: Company = null;
  public readonly disabled = input(false);
  public readonly required = input(false);

  public subscription = new Subscription();
  public companyList: SelectItem[] = [];
  public loaded = false;

  ngOnInit() {
    this.buildCompanyList();
  }

  public onCompanyChange(event: Company[]) {
    this.companyChange.emit(event);
  }

  private buildCompanyList(): void {
    this.loaded = false;
    this.companyList = [];

    this.userService.getUser().then((user) => {
      if (!user?.hasCompanies()) {
        return;
      }

      const params = new HttpParams();
      this.companyRepository.list(params).subscribe((companyList) => {
        companyList.forEach((company) => {
          this.companyList.push({ label: company.name, value: company });
        });
        this.loaded = true;
      });
    });
  }
}
